/* eslint-disable no-template-curly-in-string */
// @flow

export default {
  NoRecordsFound: 'Tidak ada catatan yang ditemukan.',
  DocumentIndex: 'Indeks dokumen',
  SubmissionIndex: 'Indeks penyerahan',
  Search: 'Mencari',
  Searching: 'Mencari...',
  Filter: 'Menyaring',
  FullTextSearch_SentenceCase: 'Pencarian teks lengkap',
  BulkDownload_SentenceCase: 'Unduhan massal',
  ExportToExcel: 'Ekspor ke Excel',
  ExpandAll_SentenceCase: 'Perluas semua',
  CollapseAll_SentenceCase: 'Tutup semua',
  BulkDownloadName_SentenceCase: 'Nama paket',
  SelectAll_SentenceCase: 'Pilih semua',
  AskQuestion: 'Ajukan Pertanyaan',
  Move: 'Bergerak',
  Edit: 'Sunting',
  OpenInOfficeOnline: 'Buka di Microsoft Office untuk web',
  EditInOfficeOnline: 'Edit di Microsoft Office untuk web',
  Security: 'Keamanan',
  Enable: 'Memungkinkan',
  Disable: 'Cacat',
  Delete: 'Menghapus',
  History: 'Sejarah',
  History_LowerCase: 'sejarah',
  ManageDocuments: 'Kelola dokumen',
  SelectDocumentsToRedact: 'Pilih dokumen yang akan disunting',
  Submissions: 'Pengajuan',
  TenderSubmissions: 'Pengajuan tender',
  Add: 'Menambahkan',
  Folder: 'Map',
  Document: 'Dokumen',
  Document_LowerCase: 'dokumen',
  Documents_LowerCase: 'dokumen',
  Folder_LowerCase: 'map',
  Folders_LowerCase: 'folder',
  Renumber: 'Memberi nomor baru',
  BulkUpload_SentenceCase: 'Unggahan massal',
  BulkDownloadOverDownloadLimit:
    'Anda telah mencapai batas ukuran unduhan sebesar 100 GB. Harap hapus file dari pilihan untuk melanjutkan.',
  Name_: 'Nama:',
  Number_: 'Nomor:',
  Retry: 'Mencoba kembali',
  FolderNotDeletedAccess:
    'KESALAHAN: Folder tidak dapat dihapus karena berisi satu atau beberapa dokumen dan/atau subfolder yang tidak boleh Anda akses.',
  FolderNotDeleted: 'KESALAHAN: Folder tidak dapat dihapus.',
  DocumentNotDeleted: 'KESALAHAN: Dokumen tidak dapat dihapus.',
  FolderNotUpdated: 'KESALAHAN: Folder tidak dapat diperbarui.',
  DocumentNotUpdated: 'KESALAHAN: Dokumen tidak dapat diperbarui.',
  ParentFolderDisabled: 'Folder induk dinonaktifkan',
  EnableDocument:
    'Folder ini berisi 1 dokumen, apakah Anda yakin ingin mengaktifkan folder ini?',
  EnableDocuments: '\u003cb\u003eAktifkan\u003c/b\u003eDokumen',
  EnableFolder:
    'Folder ini berisi 1 folder, apakah Anda yakin ingin mengaktifkan folder ini?',
  EnableFolderDocument:
    'Folder ini berisi 1 folder dan 1 dokumen, apakah Anda yakin ingin mengaktifkan folder ini?',
  EnableFolderDocuments:
    'Folder ini berisi 1 folder dan dokumen ${NumberOfDocuments}, apakah Anda yakin ingin mengaktifkan folder ini?',
  EnableFolders:
    'Folder ini berisi folder ${NumberOfFolders}, apakah Anda yakin ingin mengaktifkan folder ini?',
  EnableFoldersDocument:
    'Folder ini berisi folder ${NumberOfFolders} dan 1 dokumen, apakah Anda yakin ingin mengaktifkan folder ini?',
  EnableFoldersDocuments:
    'Folder ini berisi folder ${NumberOfFolders} dan dokumen ${NumberOfDocuments}, apakah Anda yakin ingin mengaktifkan folder ini?',
  BulkEnableFolders: 'Folder ${NumberOfFolders} akan diaktifkan.',
  BulkEnableFoldersWithImplicitFolders:
    'Untuk mengaktifkan item ini semua folder induk harus diaktifkan. Folder ${NumberOfFolders} akan diaktifkan.',
  BulkEnableOneFolder: '1 folder akan diaktifkan.',
  BulkEnableOneFolderAndDocuments:
    '1 folder dan dokumen ${NumberOfDocuments} akan diaktifkan.',
  BulkEnableOneFolderAndDocumentsWithImplicitFolders:
    'Untuk mengaktifkan item ini, semua folder induk harus diaktifkan. 1 folder dan dokumen ${NumberOfDocuments} akan diaktifkan.',
  BulkEnableOneFolderAndOneDocument: '1 folder dan 1 dokumen akan diaktifkan.',
  BulkEnableOneFolderAndOneDocumentWithImplicitFolders:
    'Untuk mengaktifkan item ini, semua folder induk harus diaktifkan. 1 folder dan 1 dokumen akan diaktifkan.',
  BulkEnableDocuments: 'Dokumen ${NumberOfDocuments} akan diaktifkan.',
  BulkEnableOneDocument: '1 dokumen akan diaktifkan.',
  BulkEnableFoldersAndOneDocument:
    'Folder ${NumberOfFolders} dan 1 dokumen akan diaktifkan.',
  BulkEnableFoldersAndOneDocumentWithImplicitFolders:
    'Untuk mengaktifkan item ini semua folder induk harus diaktifkan. Folder ${NumberOfFolders} dan 1 dokumen akan diaktifkan.',
  BulkEnableFoldersAndDocuments:
    'Folder ${NumberOfFolders} dan dokumen ${NumberOfDocuments} akan diaktifkan.',
  BulkEnableFoldersAndDocumentsWithImplicitFolders:
    'Untuk mengaktifkan item ini, semua folder induk harus diaktifkan. Folder ${NumberOfFolders} dan dokumen ${NumberOfDocuments} akan diaktifkan.',
  BulkEnableDocumentsErrorMessage:
    'KESALAHAN: Dokumen ${NumberOfDocuments} tidak dapat diaktifkan.',
  BulkEnableFoldersErrorMessage:
    'KESALAHAN: Folder ${NumberOfFolders} tidak dapat diaktifkan.',
  BulkEnableFoldersDocumentsErrorMessage:
    'KESALAHAN: folder ${NumberOfFolders} dan dokumen ${NumberOfDocuments} tidak dapat diaktifkan.',
  DisableDocument:
    'Folder ini berisi 1 dokumen, apakah Anda yakin ingin menonaktifkan folder ini?',
  DisableDocuments: '\u003cb\u003eNonaktifkan\u003c/b\u003eDokumen',
  DisableFolder:
    'Folder ini berisi 1 folder, apakah Anda yakin ingin menonaktifkan folder ini?',
  DisableFolderDocument:
    'Folder ini berisi 1 folder dan 1 dokumen, apakah Anda yakin ingin menonaktifkan folder ini?',
  DisableFolderDocuments:
    'Folder ini berisi 1 folder dan dokumen ${NumberOfDocuments}, apakah Anda yakin ingin menonaktifkan folder ini?',
  DisableFolders:
    'Folder ini berisi folder ${NumberOfFolders}, apakah Anda yakin ingin menonaktifkan folder ini?',
  DisableFoldersDocument:
    'Folder ini berisi folder ${NumberOfFolders} dan 1 dokumen, apakah Anda yakin ingin menonaktifkan folder ini?',
  DisableFoldersDocuments:
    'Folder ini berisi folder ${NumberOfFolders} dan dokumen ${NumberOfDocuments}, apakah Anda yakin ingin menonaktifkan folder ini?',
  DisableFolderConfirm:
    'Folder "${FolderName}" berisi folder lain di dalamnya, folder tersebut juga akan dinonaktifkan.',
  BulkDisableFolders: 'Folder ${NumberOfFolders} akan dinonaktifkan.',
  BulkDisableOneFolder: '1 folder akan dinonaktifkan.',
  BulkDisableOneFolderAndDocuments:
    '1 folder dan dokumen ${NumberOfDocuments} akan dinonaktifkan.',
  BulkDisableOneFolderAndOneDocument:
    '1 folder dan 1 dokumen akan dinonaktifkan.',
  BulkDisableDocuments: 'Dokumen ${NumberOfDocuments} akan dinonaktifkan.',
  BulkDisableOneDocument: '1 dokumen akan dinonaktifkan.',
  BulkDisableFoldersAndOneDocument:
    '${NumberOfFolders} folder dan 1 dokumen akan dinonaktifkan.',
  BulkDisableFoldersAndDocuments:
    'Folder ${NumberOfFolders} dan dokumen ${NumberOfDocuments} akan dinonaktifkan.',
  BulkDisableDocumentsErrorMessage:
    'KESALAHAN: Dokumen ${NumberOfDocuments} tidak dapat dinonaktifkan.',
  BulkDisableFoldersErrorMessage:
    'KESALAHAN: Folder ${NumberOfFolders} tidak dapat dinonaktifkan.',
  BulkDisableFoldersDocumentsErrorMessage:
    'KESALAHAN: folder ${NumberOfFolders} dan dokumen ${NumberOfDocuments} tidak dapat dinonaktifkan.',
  DeleteFileConfirmation: '"${FileName}" akan segera dihapus.',
  DeleteFolderConfirmation: '"${FolderName}" akan segera dihapus.',
  BulkDeleteFolders: 'Folder ${NumberOfFolders} akan dihapus.',
  BulkDeleteOneFolder: '1 folder akan dihapus.',
  BulkDeleteOneFolderAndDocuments:
    '1 folder dan dokumen ${NumberOfDocuments} akan dihapus.',
  BulkDeleteOneFolderAndOneDocument: '1 folder dan 1 dokumen akan dihapus.',
  BulkDeleteDocuments: 'Dokumen ${NumberOfDocuments} akan dihapus.',
  BulkDeleteOneDocument: '1 dokumen akan dihapus.',
  BulkDeleteFoldersAndOneDocument:
    '${NumberOfFolders} folder dan 1 dokumen akan dihapus.',
  BulkDeleteFoldersAndDocuments:
    'Folder ${NumberOfFolders} dan dokumen ${NumberOfDocuments} akan dihapus.',
  BulkDeleteDocumentsErrorMessage:
    'KESALAHAN: Dokumen ${NumberOfDocuments} tidak dapat dihapus.',
  BulkDeleteFoldersErrorMessage:
    'KESALAHAN: Folder ${NumberOfFolders} tidak dapat dihapus.',
  BulkDeleteFoldersDocumentsErrorMessage:
    'KESALAHAN: folder ${NumberOfFolders} dan dokumen ${NumberOfDocuments} tidak dapat dihapus.',
  AddFolder: 'Tambahkan folder',
  AddDocument: 'Tambahkan dokumen',
  CopyLink_SentenceCase: 'Salin tautan',
  SendToKira_SentenceCase: 'Kirim ke Kira',
  Actions: 'Tindakan',
  Download: 'Unduh',
  DownloadPart: 'Unduh bagian ${number}',
  BulkDownloadIsNotSwitchedOnContactAdmin_Gen2:
    'Pengunduhan massal tidak diaktifkan. Hubungi Administrator untuk informasi lebih lanjut',
  Disabled: 'Dengan disabilitas',
  FileTypeUnknown: 'Mengajukan',
  FileTypeAcrobat: 'Akrobat PDF',
  FileTypeArchive: 'Arsip',
  FileTypeAudio: 'Berkas audio',
  FileTypeCode: 'Kode',
  FileTypeContact: 'Kontak',
  FileTypeEmail: 'E-mail',
  FileTypeExcel: 'Unggul',
  FileTypeImage: 'Gambar',
  FileTypeLayoutAndDesign: 'Dokumen desain',
  FileTypePowerpoint: 'Powerpoint',
  FileTypeText: 'Teks',
  FileTypeVideo: 'Video',
  FileTypeVisio: 'Visio',
  FileTypeWord: 'Kata',
  SavingAllowed: 'Menyimpan diperbolehkan',
  SavingDenied: 'Penyimpanan ditolak',
  PrintingAllowed: 'Pencetakan diizinkan',
  PrintingDenied: 'Pencetakan ditolak',
  FileExtensionEmpty: 'tidak ada ekstensi',
  OneBulkDownloadInProgress:
    '1 unduhan massal sedang berlangsung - ${progress}%',
  NumberOfBulkDownloadInProgress:
    '${number} unduhan massal sedang berlangsung - ${progress}%',
  Cancel: 'Membatalkan',
  Expand: 'Memperluas',
  Collapse: 'Runtuh',
  FolderEmpty: 'Folder kosong',
  UseChromeToBulkUpload:
    'Gunakan Chrome untuk mengunggah dokumen dan folder secara massal.',
  RenumberCallToAction: 'Memberi nomor baru',
  Archives: 'Arsip',
  BulkDownloadUnavailable:
    'Pengunduhan massal saat ini tidak tersedia. Silakan coba lagi nanti',
  PreviewNotAvailable: 'Pratinjau tidak tersedia',
  DocumentIsTooLargeToPreview:
    'Dokumen ini terlalu besar untuk dilihat pratinjaunya. Anda perlu mengunduh dokumen untuk melihatnya.',
  DocumentIsTooLargeToPreviewWithoutDownload:
    'Dokumen ini terlalu besar untuk dipratinjau',
  FileCannotBePreviewed: 'Berkas ini tidak dapat dipratinjau.',
  OwnerHasSecuredThisDocument: 'Pemilik telah mengamankan dokumen ini',
  ThisDocumentIsSecuredWithAdobeRightsManagement:
    'Dokumen ini dilindungi oleh Adobe Rights Management. Anda memerlukan Adobe Acrobat Reader dan online untuk melihat dokumen ini.',
  ThisDocumentIsSecuredWithMicrosoftRightsManagement:
    'Dokumen ini dilindungi oleh Microsoft Rights Management. Anda memerlukan Microsoft Office dan online untuk melihat dokumen ini.',
  SecuredPdfHelpLink:
    'Pelajari selengkapnya tentang \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003emelihat dokumen PDF.\u003c/a\u003e',
  SecuredPdfHelpLinkMac:
    'Pelajari selengkapnya tentang \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003emelihat dokumen PDF.\u003c/a\u003e',
  SecuredDocHelpLink:
    'Pelajari selengkapnya tentang \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003emelihat dokumen Office.\u003c/a\u003e',
  YourDownloadIsBeingPrepared: 'Unduhan Anda sedang dipersiapkan...',
  OwnerHasSecuredTheseDocuments:
    'Pemilik telah mengamankan dokumen-dokumen ini',
  SecuredPdfAndDocHelpLink:
    'Pelajari selengkapnya tentang \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003emelihat dokumen PDF\u003c/a\u003eatau \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003edokumen Office.\u003c/a\u003e',
  SecuredPdfAndDocHelpLinkMac:
    'Pelajari selengkapnya tentang \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003emelihat dokumen PDF\u003c/a\u003eatau \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003edokumen Office.\u003c/a\u003e',
  DocumentsAreSecuredWithMicrosoftOrAdobeRightsManagement:
    'Dokumen-dokumen ini diamankan dengan Adobe Rights Management atau Microsoft Rights Management. Anda memerlukan Adobe Acrobat Reader atau Microsoft Office dan online untuk melihat dokumen-dokumen ini.',
  UnableToDownloadThisFileTryAgain: 'Tidak dapat mengunduh berkas ini.',
  DownloadStarted: 'Unduhan Dimulai',
  Close: 'Menutup',
  GotIt: 'Mengerti',
  Preview: 'Pratinjau',
  DontShowThisAgain: 'Jangan tampilkan ini lagi',
  BulkDownloadPrepareTitle: 'Unduhan Anda sedang dipersiapkan...',
  BulkDownloadPrepareAwareMessage:
    'Perlu diperhatikan, semakin besar unduhan, semakin lama waktu yang dibutuhkan untuk memprosesnya.',
  BulkDownloadPrepareMessage:
    'Email akan dikirim ke <strong>${email}</strong> saat unduhan Anda siap.',
  BulkDownloadLimitError:
    'Anda telah mencapai batas unduhan sebesar ${limitedNumnerOfItems} file atau ${limitedFileSize}. Harap hapus file dari pilihan untuk melanjutkan.',
  LinkCopiedToClipboard: 'Tautan disalin ke papan klip',
  RestoreDocuments: 'Mengembalikan dokumen',
  RepairNumbering: 'Perbaikan penomoran',
  BulkUpdate: 'Pembaruan massal',
  GenerateFolders: 'Hasilkan folder',
  NotificationsReport: 'Laporan notifikasi',
  DownloadHelpInfo:
    'Jika unduhan belum dimulai setelah beberapa detik, silakan gunakan',
  DirectLink: 'tautan langsung',
  YourDocumentsAreDownloading: 'Dokumen Anda sedang diunduh.',
  DocumentRenamed: 'Dokumen telah diganti nama.',
  FolderRenamed: 'Folder telah diganti nama.',
  FolderRenamedRenumber: 'Penomoran ulang untuk memperbarui konten folder',
  DocumentsNotificationList: 'Daftar Pemberitahuan Dokumen',
  UserDocumentNotificationSettings: 'Pengaturan Pemberitahuan Dokumen Pengguna',
  IntervalType: 'Tipe Interval',
  NumberOfUsers: 'Jumlah Pengguna',
  NotificationList: 'Daftar Notifikasi',
  ExportSelectedItemsToExcel: 'Ekspor [Number] ke Excel',
  ToEmail: 'Untuk mengirim email',
  FromSentDateSydneyTime: 'Dari Tanggal Terkirim (Waktu Sydney)',
  ToSentDateSydneyTime: 'Tanggal Pengiriman (Waktu Sydney)',
  DocID: 'ID Dokumen',
  DocName: 'Nama Dokumen',
  To: 'Ke',
  UserType: 'Tipe Pengguna',
  SentDateSydneyTime: 'Tanggal pengiriman (Waktu Sydney)',
  Previous: 'Sebelumnya',
  Next: 'Berikutnya',
  DisableFolderConfirmHeader: 'Anda akan menonaktifkan folder',
  ThereAreNoAvailableFoldersAndDocumentsAtTheMoment:
    'Tidak ada dokumen atau folder yang tersedia saat ini.',
  ThereAreNoDocumentsOrFoldersMatchingFilterCriteria:
    'Tidak ada dokumen atau folder yang cocok dengan kriteria filter.',
  DeleteFolderConfirmHeader: 'Anda akan menghapus folder',
  DeleteFileConfirmHeader: 'Anda akan menghapus file',
  MoveItemDialogUseDestinationFolderSecurity:
    'Gunakan pengaturan keamanan folder dari ${destinationFolderName}',
  MoveItemDialogSecuritySettingsLabel: 'Pengaturan Keamanan',
  MoveItemDialogUseCurrentFolderSecurity:
    'Gunakan pengaturan keamanan saat ini',
  MoveItemDialogNotifyCheckbox: 'Beritahu orang ketika akses diberikan',
  MoveItemNewLocation: 'Lokasi baru: ',
  DontHavePermissionToMoveFolder:
    'Anda tidak memiliki izin untuk memindahkan folder ini.',
  DontHavePermissionToMoveFolders:
    'Anda tidak memiliki izin untuk memindahkan folder ini.',
  DontHavePermissionToMoveItemsMoveIntoFolder:
    'Anda tidak memiliki izin untuk memindahkan item ke folder ini.',
  SecuredFileIsTooLargeToPreview:
    'File yang Anda coba pratinjau terlalu besar. Anda dapat mengunduhnya sebagai gantinya.',
  SecuredFileIsTooLargeToPreviewWithoutDownload:
    'Berkas yang Anda coba pratinjau terlalu besar.',
  BeforeYouDownload: 'Sebelum Anda mengunduh',
  SecuredPreviewPdfHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003ePelajari selengkapnya tentang melihat dokumen PDF.\u003c/a\u003e',
  SecuredPreviewPdfHelpLinkMac:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003ePelajari selengkapnya tentang melihat dokumen PDF.\u003c/a\u003e',
  SecuredPreviewDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003ePelajari selengkapnya tentang melihat dokumen Office.\u003c/a\u003e',
  StartYourDataRoomAndAddDocument:
    'Mulai ruang data Anda dan tambahkan dokumen.',
  UploadDocuments: 'Unggah dokumen',
  ExpiredDocumentAccess:
    'Akses Anda ke dokumen ini telah kedaluwarsa. Hubungi administrator ruang data untuk mendapatkan akses.',
  MultipleDragDropInfo:
    'Pilih, seret, dan jatuhkan dokumen dan folder untuk dipindahkan',
  DemoMultipleDragDropTitle: 'Bagaimana cara kerjanya',
  Zipping: 'Membuat ritsleting',
  Processing: 'Pengolahan...',
  YourFilesAreReadyToDownload: 'File Anda siap untuk diunduh',
  ThisBulkDownloadIsSplit:
    'Unduhan ini terlalu besar dan kami telah membaginya menjadi beberapa bagian. Tautan ini juga dapat ditemukan di email Anda.',
  BulkDownloadEmptyFoldersNote: 'Folder kosong tidak akan diunduh.',
  NotifyPeopleWhenAccessIsGranted: 'Beritahu orang ketika akses diberikan',
  BulkEnableConfirmHeader: 'Aktifkan folder dan dokumen',
  BulkDisableConfirmHeader: 'Nonaktifkan folder dan dokumen',
  CopyDocumentsInProgress: 'Pemuatan indeks dokumen sedang berlangsung',
  SomeDocumentsAreSecuredLink:
    'Beberapa dokumen diamankan oleh Administrator. Untuk membukanya, Anda perlu:',
  EnableTruncation: 'Aktifkan Pemotongan',
  OptimizeFilePathForWindows: 'Mengoptimalkan jalur file untuk Windows',
  TruncationNoteForWindows:
    'Untuk pengguna Windows, Anda perlu menggunakan 7-Zip pada Windows 10 untuk mengekstrak.',
  Restore: 'Memulihkan',
  Current: 'Saat ini',
  AddedBy: 'Ditambahkan oleh',
  UpdatedBy: 'Diperbarui oleh',
  RestoreThisVersion: 'Pulihkan versi ini',
  AdobeAcrobatReader: 'Pembaca Adobe Acrobat',
  MicrosoftOffice: 'Kantor Microsoft',
  InternetConnection: 'Koneksi internet',
  BulkDeleteConfirmHeader: 'Hapus folder dan dokumen',
  Preparing: 'Sedang mempersiapkan...',
  SomeSavingDeniedFilesSelected:
    'Dokumen ${number} memiliki kebijakan "Penyimpanan Ditolak" dan tidak akan diunduh.',
  RestoreDocumentSuccessMessage: '${title} telah dipulihkan',
  RestoreVersionNumberButtonText: 'Pulihkan versi ${versionNumber}',
  HistoryDialogNothingChangeMessage: 'Versi ini sama dengan versi saat ini',
  HistoryDialogNoDocumentChangeMessage: 'Konten dokumen belum diubah',
  HistoryDialogNoNameAndNumberChangeMessage:
    'Nama dan nomor dokumen belum diubah',
  ResetViewAsToDownload: 'Setel ulang filter "Lihat sebagai" untuk mengunduh.',
  NoPermissionToDownloadTooltip:
    'Administrator telah menonaktifkan unduhan massal untuk ruangan ini',
  Remove: 'Menghapus',
  Reset: 'Mengatur ulang',
  ResetNow: 'Setel ulang sekarang',
  ResetDialogTitle: 'Setel ulang proses pengiriman',
  ResetDialogContent:
    'Apakah Anda yakin ingin mengatur ulang proses pengiriman? Tanggal dan waktu penutupan akan diatur ulang.',
  Confirm: 'Mengonfirmasi',
  Region: 'Wilayah',
  KiraSuccessfullyConnectedTitle: 'Berhasil terhubung ke Kira',
  KiraSuccessfullyConnectedFirstLine:
    'Anda sekarang dapat mengirim dokumen ke Kira untuk mengungkapnya',
  KiraSuccessfullyConnectedSecondLine:
    'informasi yang relevan dari kontrak dan dokumen terkait.',
  KiraProjectsLoading: 'Proyek sedang dimuat...',
  KiraSelectProject: 'Pilih proyek di Kira...',
  KiraSendDocument: 'Kirim dokumen ke Kira',
  KiraConnect: 'Hubungi Kira',
  KiraCompanyUrl: 'URL perusahaan Kira Anda',
  KiraApiToken: 'Token API Kira',
  KiraUnableToConnect:
    'Kami tidak dapat terhubung ke Kira. Harap verifikasi wilayah dan token Anda, lalu coba lagi.',
  KiraConfigError:
    'Terjadi kesalahan saat memuat konfigurasi. Silakan coba lagi.',
  KiraProjectsLoadError:
    'Kami tidak dapat mengambil proyek Anda dari Kira. Silakan coba lagi.',
  KiraSendDocumentError:
    'Terjadi kesalahan saat mengirim dokumen ke Kira. Silakan coba lagi.',
  KiraSendingDocument: "Mengirim '${documentName}' ke Kira",
  KiraDocumentSent: "'${documentName}' dikirim ke Kira",
  Redact: 'Menyusun',
  RedactDocuments: 'Menyunting dokumen',
  EditRedact: 'Edit redaksi',
  RedactionIsNotAvailable: 'Redaksi tidak tersedia',
  RedactGetDocumentError:
    'Kami tidak dapat memperoleh dokumen ini. Silakan coba lagi',
  RedactBurnDocumentError:
    'Kami tidak dapat menyunting dokumen ini. Silakan coba lagi',
  RedactFileTooLarge:
    'File yang lebih besar dari ${fileSize} tidak didukung untuk penyuntingan saat ini. Optimalkan ukuran dokumen dan coba lagi.',
  RedactSaveDialogTitle: 'Simpan sebagai dokumen baru yang telah disunting',
  MultipleDocumentsErrorDescription:
    '${numberOfDocuments} dokumen yang ditandai tidak dapat diproses. Anda dapat mencoba dan mengunggah dokumen lagi.',
  SingleDocumentErrorDescription:
    '1 dokumen ditandai tidak dapat diproses. Anda dapat mencoba dan mengunggah dokumen lagi.',
  MultipleDocumentsInProgressDescription:
    'Dokumen ${numberOfDocuments} yang ditandai belum selesai diproses.',
  SingleDocumentInProgressDescription:
    '1 dokumen yang ditandai belum selesai diproses.',
  CancelBulkRedaction: 'Batalkan penyuntingan massal',
  CancelBulkRedactionMessage: `Anda akan menghentikan proses penyuntingan. Menghentikan penyuntingan akan menghentikan penyuntingan pada dokumen saat ini dan mengembalikan Anda ke indeks dokumen.`,
  StopRedaction: 'Hentikan penyuntingan',
  DocumentLocation: 'Lokasi dokumen',
  SecurityControls: 'Kontrol keamanan',
  SecuritySettings: 'Pengaturan keamanan',
  UseFolderSecurityFrom: 'Gunakan pengaturan keamanan folder dari',
  UseSecurityFromOpenedDocument:
    'Gunakan pengaturan keamanan dari dokumen yang dibuka',
  UseSecurityFromOriginalDocument:
    'Gunakan pengaturan keamanan dari dokumen asli',
  UseSecurityFromOriginalFolder: 'Gunakan pengaturan keamanan dari folder asli',
  UseSecurityFromOriginalFoldersAndDocuments:
    'Gunakan pengaturan keamanan dari folder asli dan dokumen asli',
  DocumentWillBeDisabledByDefault: 'Dokumen akan dinonaktifkan secara default.',
  DocumentsAndFoldersWillBeDisabledByDefault:
    'Folder dan dokumen akan dinonaktifkan secara default.',
  ImportDataRoomError:
    'Impor dengan trackingId ${trackingId} mengalami kesalahan. Silakan coba lagi.',
  RedactionError: '${fileName} tidak dapat disunting, mohon coba lagi.',
  RedactionHowRedactionSavingWorks: 'Cara kerja penyimpanan redaksi',
  RedactionEducationDialogForAdministrators: 'Untuk Administrator',
  RedactionEducationDialogForGuests: 'Untuk Tamu',
  RedactionEducationDialogPreviewDownload: 'Pratinjau/Unduh',
  RedactionEducationDialogEditing: 'Mengedit',
  RedactionEducationDialog1Layer: 'dokumen 1 lapis',
  RedactionEducationDialog2Layer: 'dokumen 2 lapis',
  RedactionEducationDialogRedactionsAreBakedIn: 'Redaksi sudah tertanam',
  RedactionEducationDialogRedactionsAreEditable: 'Redaksi dapat diedit',
  RedactionSaveAsNewDocument: 'Simpan sebagai dokumen baru',
  RedactionHowSavingWorks: 'Cara kerja menabung',
  ChangesYouMadedWillNotBeSaved:
    'Perubahan yang Anda buat tidak akan disimpan.',
  IsRedacted: 'telah disunting.',
  DocumentsAddedFrom: 'Dokumen ditambahkan dari ${dataroomName}.',
  GoToFile: 'Tunjukkan padaku dokumennya',
  GoToImportFolder: 'Tunjukkan padaku foldernya',
  Thanks: 'Terima kasih',
  Validation_DuplicatedDocumentInFolder:
    'Dokumen ${documentName} sudah ada di ${folderName}',
  Validation_NameCannotBeEmpty: 'Nama tidak dapat kosong.',
  Continue: 'Melanjutkan',
  RedactingMessage:
    'Proses penyuntingan mungkin memerlukan waktu yang lama. Harap jangan menyegarkannya',
  Name: 'Nama',
  Number: 'Nomor',
  LearnMore: 'Pelajari lebih lanjut',
  BulkActionsNoItemsWillBeAffected:
    'Tidak ada item yang akan terpengaruh oleh operasi ini.',
  Saving: 'Penghematan',
  YouCanKeepWorking: 'Anda dapat terus bekerja.',
  Copy: 'Menyalin',
  CopyDocument: 'Salin dokumen ke',
  CopyFolder: 'Salin folder ke',
  Import: 'Impor',
  DataRooms: 'Ruang Data',
  Accept: 'Menerima',
  TermOfAccess: 'Jangka waktu akses',
  TermOfAccessCheckbox:
    'Saya telah membaca, memahami dan menyetujui persyaratannya',
  ImportingDataFrom: 'Menambahkan dokumen dari ${dataroomName}.',
  Refresh: 'Menyegarkan',
  ImportTo: 'Impor ke',
  ImportError: 'Kesalahan impor, silakan hubungi administrator.',
  Back: 'Kembali',
  LastAccessed: 'Diakses',
  NeverAccessed: 'Tidak pernah diakses',
  Remaining: 'tersisa',
  SubmissionWindowIsOpen: 'Jendela pengiriman terbuka.',
  SubmissionWindowHasEnd:
    'Jendela pengiriman telah berakhir. Dokumen yang Anda unggah sekarang akan ditandai sebagai terlambat.',
  FromYourComputer: 'Dari komputer Anda',
  FromAnotherDataRoom: 'Dari ruang data lain',
  FromFolderStructure: 'Dari struktur folder',
  FromDataRoom: 'Dari ruang data',
  AddFromDataRoom: 'Tambahkan dari ruang data',
  AddFromFolderStructure: 'Tambahkan dari struktur folder',
  ImportDialogDataRoomScreenDialogTitle: 'Tambahkan dokumen dari ruang data',
  ImportDialogDataRoomScreenHeading:
    'Pilih Ruang Data yang berisi dokumen yang ingin Anda tambahkan.',
  ImportDialogTermOfAccessScreenDialogTitle:
    'Tambahkan dokumen dari ${dataroomName}',
  ImportDialogTermOfAccessScreenHeading:
    'Anda harus menerima Ketentuan Akses sebelum Anda dapat menambahkan dokumen dari ruang data ini.',
  ImportDialogDataRoomScreenRadioBtn: 'Tambahkan dokumen dari ruang data ini',
  ImportDialogDocumentListScreenHeading:
    'Pilih satu atau lebih dokumen untuk ditambahkan ke ruang data Anda.',
  ImportDialogEmptyDataRoom: 'Tidak ada ruang data yang dapat Anda akses.',
  ImportDialogEmptyDocument:
    'Tidak ada dokumen yang ditambahkan dari ruang data ini.',
  ImportDialogDocumentListScreenDialogTitle:
    'Tambahkan dokumen dari ${dataroomName}',
  UserTypeCode_ADM: 'Administrator',
  UserTypeCode_DOP: 'Penerbit',
  UserTypeCode_GUE: 'Tamu',
  UserTypeCode_USQ: 'Penampil Terbatas',
  UserTypeCode_USR: 'Penonton',
  QnaRoleCode_QVW: 'Penampil Pertanyaan',
  QnaRoleCode_BAP: 'Penyetuju Penawar',
  QnaRoleCode_BAA: 'Penulis Penawar',
  QnaRoleCode_BMC: 'Kontak Utama Penawar',
  QnaRoleCode_IAP: 'Pemberi Persetujuan Internal',
  QnaRoleCode_IAA: 'Penulis Internal',
  QnaRoleCode_IMC: 'Kontak Utama Internal',
  QnaRoleCode_IOB: 'Pengamat Internal',
  QnaRoleCode_QAU: 'Pertanyaan Penulis',
  QnaRoleCode_QAP: 'Penyetuju Pertanyaan',
  QnaRoleCode_ADR: 'Penyusun Jawaban',
  QnaRoleCode_AAU: 'Jawaban Penulis',
  QnaRoleCode_AAP: 'Jawaban Penyetuju',
  QnaRoleCode_QAA: 'Tanya Jawab Administrator',
  QnaRoleCode_QAO: 'Tanya Jawab Pengamat Kontrol Penuh',
  QnaRoleCode_QOV: 'Tanya Jawab Hanya Lihat Pengamat',
  DemoRoom: '*DEMO* - ${dataroomName}',
  SearchDocuments_InputPlaceholder:
    'Masukkan kata kunci, atau nama dan nomor dokumen atau folder',
  SearchDocuments_Find: 'Menemukan',
  SearchDocuments_Results: 'Hasil',
  SearchDocuments_FullTextSearchSummary:
    '${totalItems} dokumen${plural} akan mencocokkan konten',
  SearchDocuments_DocumentSummary:
    '${totalItems} dokumen${plural} akan mencocokkan judul dan nomor dan kode',
  SearchDocuments_FolderSummary:
    'Folder ${totalItems}${plural} akan mencocokkan judul, nomor, dan kode',
  New: 'BARU',
  Browse: 'Jelajahi',
  ImportFolder_GlobalActionButton: 'Struktur folder impor',
  ImportFolder_Title: 'Impor struktur folder Anda',
  ImportFolder_Step1_DragDropDescription1:
    'Seret dan lepas atau telusuri file Excel untuk mengimpor folder.',
  ImportFolder_Step1_DragDropDescription2:
    'Catatan: Folder dinonaktifkan saat diimpor.',
  ImportFolder_Step1_DragDropDescription3:
    'Format file Excel Anda dengan nomor folder sebagai kolom A dan nama folder sebagai kolom B atau cukup {0}',
  ImportFolder_Step1_FileUploaded: '{0} diunggah',
  ImportFolder_Step1_DownloadTemplateFile: 'Unduh templat excel',
  ImportFolder_Step1_Heading: 'Anda mengimpor struktur folder ke {0}',
  ImportFolder_Step2_Title: 'Tinjau dan selesaikan impor Anda',
  ImportFolder_Step2_SuccessMessage: 'Folder Anda telah diimpor.',
  Document_Preview: 'Pratinjau dokumen',
  ErrorWhileDownloadingFile:
    'Terjadi kesalahan saat mencoba mengunduh, silakan hubungi Dukungan Pelanggan kami dengan ${ErrorCode}',
  CannotDownloadingFile: 'Tidak dapat mengunduh berkas. ',
  ClickToSeeDetails: 'Klik untuk melihat detailnya',
  TryAgain: 'Coba lagi',
  NumberingUpdatedFor: 'Penomoran diperbarui untuk',
  Items: 'Barang',
  YoureAboutToChangeTheNumberingOn: 'Anda akan mengubah penomoran pada',
  ThisMayHaveAnImpactOnPeopleReferencingTheDocumentOnThisProject:
    'Hal ini mungkin berdampak pada orang yang merujuk dokumen pada proyek ini.',
  AllDocuments: 'Semua dokumen',
  AllQnaAndAttachments: 'Semua Q&A dan lampiran',
  AllSubmissionDocuments: 'Semua dokumen penyerahan',
  AllEvaluationAttachments: 'Semua lampiran evaluasi',
  AllUserActivityDocumentViewsReports:
    'Semua log aktivitas berdasarkan laporan tampilan orang & dokumen',
  IncludeDocuments: 'Sertakan Dokumen',
  IncludeSubmissionDocuments: 'Sertakan Dokumen Pengajuan',
  IncludeEvaluationAttachments: 'Sertakan Lampiran Evaluasi',
  IncludeQna: 'Sertakan Q&A',
  IncludeQnaAttachments: 'Sertakan Lampiran Tanya Jawab',
  IncludeDisabledDocuments: 'Sertakan dokumen yang dinonaktifkan',
  Documents: 'Dokumen',
  SubmissionDocuments: 'Dokumen penyerahan',
  EvaluationAttachments: 'Lampiran evaluasi',
  QnaAttachments: 'Lampiran Q&A',
  DisabledDocuments: 'Dokumen dinonaktifkan',
  DocumentsVisibleTo: 'Dokumen terlihat oleh',
  SubmissionDocumentsVisibleTo: 'Dokumen penyerahan terlihat oleh',
  QnaAndAttachmentsVisibleTo: 'Tanya Jawab dan lampiran terlihat oleh',
  QnaAttachmentsVisibleTo: 'Lampiran Q&A terlihat oleh',
  QnaVisibleTo: 'Tanya Jawab terlihat oleh',
  IncludeDisabledDocumentsWarningMessage:
    'Menyertakan dokumen yang dinonaktifkan akan menampilkan dokumen yang saat ini tidak terlihat oleh tim yang dipilih. Pilihan ini tidak direkomendasikan.',
  AllSubTeams: 'Semua sub-tim',
  AllSecurityGroups: 'Semua grup keamanan',
  NoSubTeams: 'Tidak ada sub-tim',
  AdminOnlyFullArchive: 'Hanya admin - arsip lengkap',
  Team: 'Tim',
  SubTeam: 'Sub-tim',
  ArchiveName: 'Nama arsip',
  Options: 'Pilihan',
  Summary: 'Ringkasan',
  CreateArchive: 'Buat arsip',
  IncludeInArchive: 'Sertakan dalam Arsip',
  VisibleTo: 'Terlihat oleh',
  SubmissionDocuments_LowerCase: 'dokumen penyerahan',
  EvaluationAttachments_LowerCase: 'lampiran evaluasi',
  Qna: 'Tanya Jawab',
  QnaAndAttachments_LowerCase: 'Lampiran Q&A',
  DisableDocuments_LowerCase: 'dokumen dinonaktifkan',
  Questions_LowerCase: 'pertanyaan',
  Attachments_LowerCase: 'lampiran',
  DocumentViewsReports_LowerCase: 'laporan tampilan dokumen',
  ActivityLogsByPerson_LowerCase: 'log aktivitas berdasarkan orang',
  InProgress: 'Sedang berlangsung',
  Expired: 'Kedaluwarsa',
  Failed: 'Gagal',
  YourArchiveIsBeingGenerated: 'Arsip Anda sedang dibuat...',
  YourArchiveHasBeenQueued: 'Arsip Anda telah diantrekan.',
  AnEmailWillBeSentTo: 'Email akan dikirim ke',
  WithADownloadLinkWhenTheArchiveIsReady:
    'dengan tautan unduhan saat arsip sudah siap.',
  ContactSupport: 'Hubungi dukungan',
  SomethingWentWrong: 'Ada yang salah.',
  WeAreUnableToProcessYourArchiveRequest:
    'Kami tidak dapat memproses permintaan arsip Anda.',
  Retrieving: 'Mengambil kembali',
  FullArchiveAdminOnly: 'Arsip lengkap - Hanya admin',
  Filtered: 'Tersaring',
  CreateYourFirstArchive: 'Buat arsip pertama Anda.',
  Becomes_LowerCase: 'menjadi',
  TruncationType: 'Jenis pemotongan',
  AutoTruncate: 'Pemotongan otomatis',
  DoNotTruncate: 'Jangan dipotong',
  KeepLastSegmentOfNumbers: 'Simpan segmen angka terakhir',
  KeepNumbersOnly: 'Simpan hanya angka',
  KeepNamesOnly: 'Simpan nama saja',
  FullArchiveHelpText:
    'Administrator Ruang Data dapat melihat semua dokumen dan lampiran Tanya Jawab.',
  HowArchivesWork: 'Cara kerja arsip',
  ArchivesContainTheFullFilePathForEveryArchivedDocument:
    'Arsip berisi jalur file lengkap untuk setiap dokumen yang diarsipkan.',
  FilePathsAreLimitedTo260Characters:
    'Jalur berkas dibatasi hingga 260 karakter.',
  YouMayNeedToTruncateTheFilePaths:
    'Anda mungkin perlu memotong jalur berkas sehingga Anda dapat melihatnya di komputer Anda.',
  YouCanUseAZipApplicationToViewArchivesWithLongFilePaths:
    'Sebagai alternatif, Anda dapat menggunakan aplikasi ZIP untuk melihat arsip dengan jalur file yang panjang.',
  YourArchiveIsDownloading: 'Arsip Anda sedang diunduh.',
  DoNotTruncateHelpText:
    'Anda dapat menggunakan aplikasi ZIP untuk mengekstrak dokumen dengan jalur file yang panjang.',
  Share: 'Membagikan',
  SecureShare_Capitalize: 'Berbagi Aman',
  SecureShare_SentenceCase: 'Berbagi dengan aman',
  ValidateEmailToView: 'Validasi email untuk melihat',
  ValidateEmailToViewDescription:
    'Orang perlu memvalidasi alamat email mereka sebelum melihat dokumen.',
  EnterPasscodeToView: 'Masukkan kode sandi untuk melihat',
  EnterPasscodeToViewDescription:
    'Tetapkan kode sandi untuk dimasukkan orang sebelum mereka dapat melihat dokumen.',
  AnyoneWithALinkCanView: 'Siapa pun yang memiliki tautan dapat melihat',
  AnyoneWithALinkCanViewDescription:
    'Orang yang memiliki tautan akan memiliki akses tidak aman ke dokumen tersebut.',
  NoAccess: 'Tidak ada akses',
  NoAccessDescription:
    'Orang dengan tautan bersama tidak dapat lagi melihat dokumen tersebut.',
  SecureShareLinkSettings: 'Kontrol akses ke tautan yang Anda bagikan',
  Watermark: 'Watermark',
  LinkExpiresIn: 'Tautan kedaluwarsa dalam ${duration} (${timezone})',
  LinkExpiredDuration:
    'Tautan telah kedaluwarsa ${duration} lalu (${timezone})',
  LinkExpirationDate: 'Tetapkan tanggal dan waktu untuk kedaluwarsa tautan',
  On: 'Pada',
  Off: 'Mati',
  CreateWatermark: 'Buat watermark',
  None: 'Tidak ada',
  AnyoneWithTheLinkCanviewTheDocument:
    'Siapa pun yang memiliki tautan dapat melihat dokumen tersebut.',
  PeopleNeedToValidateTheirEmailToViewTheDocument:
    'Orang perlu memvalidasi email mereka untuk melihat dokumen.',
  PeopleNeedToEnterThePasscodeToViewTheDocument:
    'Orang perlu memasukkan kode sandi ( <strong data-ansarada-ccd="true">${passCode}</strong> ) untuk melihat dokumen.',
  SecureShareLink: 'Tautan Bagikan Aman',
  SecureShareLinkCopy: 'Tautan aman untuk Anda salin dan bagikan',
  SaveAndRemoveAccess_SentenceCase: 'Simpan dan hapus akses',
  AccessPasscode: 'Masukkan kode sandi untuk mengakses tautan',
  SettingsSaved: 'Pengaturan disimpan',
  LinkShareWithCode: 'Bagikan tautan dengan kode',
  LinkShareWithEmail: 'Bagikan tautan melalui email',
  LinkShare: 'Bagikan tautan',
  AllDownloadedCopiesWillSelfDestruct:
    'Semua salinan yang diunduh akan hancur sendiri.',
  NeedHelpSharingALinkOrDocument:
    'Butuh bantuan untuk membagikan tautan atau dokumen?',
  HowDoIExpireAllLinksToADocument:
    'Bagaimana cara menghapus semua tautan ke suatu dokumen?',
  WhatDoIDoToDenyADownload:
    'Apa yang harus saya lakukan untuk menolak unduhan?',
  FindOutMoreAboutSecureShare:
    'Pelajari lebih lanjut tentang berbagi dokumen dengan aman',
  SaveAndCopyLink_SentenceCase: 'Simpan dan salin tautan',
  ShareDocumentSecurely_SentenceCase: 'Bagikan dokumen dengan aman',
  ShareDocumentEmptyStateDescription:
    'Pilih dokumen dari kolom kelola dokumen untuk mulai berbagi.',
  FirstTellUsWhoYouAre: 'Pertama, beritahu kami siapa Anda',
  ToAccessTheSharedDocumentWeNeedToVerifyYourEmailAddress:
    'Untuk mengakses dokumen bersama, kami perlu memverifikasi alamat email Anda.',
  WeWillSendYouAnEmailSoYouCanAccessTheSharedDocument:
    'Kami akan mengirimkan email kepada Anda sehingga Anda dapat mengakses dokumen yang dibagikan.',
  EnterAnEmailAddress: 'Masukkan alamat email',
  EnterAValidEmailAddress: 'Masukkan alamat email yang valid',
  EmailIsRequired: 'Email diperlukan',
  VerifyMyEmail_SentenceCase: 'Verifikasi email saya',
  FirstEnterThePasscode: 'Pertama, masukkan kode sandi',
  ToAccessTheSharedDocumentYouNeedToEnterThePasscode:
    'Untuk mengakses dokumen yang dibagikan, Anda perlu memasukkan kode sandi.',
  ReachOutToThePersonWhoSharedDocumentYouNeedToEnterThePasscode:
    'Hubungi orang yang membagikan tautan kepada Anda untuk mengetahui lebih lanjut.',
  EnterTheAccessPasscode: 'Masukkan kode akses',
  ViewDocument_SentenceCase: 'Lihat dokumen',
  TheDocumentIsNoLongerAvailable: 'Dokumen tersebut tidak tersedia lagi',
  YourAccessMayHaveBeenRemovedOrTheDocumentDeleted:
    'Akses Anda mungkin telah dihapus atau dokumen terhapus.',
  ReachOutToThePersonWhoSharedTheLinkWithYouToFindOutMore:
    'Hubungi orang yang membagikan tautan kepada Anda untuk mengetahui lebih lanjut.',
  SecurityControlsOn: 'Kontrol keamanan aktif',
  SecurityControlsOff: 'Kontrol keamanan mati',
  CopyingAllowed: 'Menyalin diizinkan',
  CopyingDenied: 'Penyalinan ditolak',
  EditingAllowed: 'Mengedit diperbolehkan',
  EditingDenied: 'Pengeditan ditolak',
  DenyCopyingDisabled: 'Penolakan penyalinan dinonaktifkan',
  DenyEditingDisabled: 'Penolakan pengeditan dinonaktifkan',
  DenyPrintingDisabled: 'Penolakan pencetakan dinonaktifkan',
  DenySavingDisabled: 'Tolak penyimpanan dinonaktifkan',
  Redirecting: 'Mengalihkan...',
  CheckYourInbox: 'Periksa kotak masuk Anda',
  YouCanOnlyViewThisDocumentFromTheSameDeviceUsedToVerifyYourEmail:
    'Anda hanya dapat melihat dokumen ini dari perangkat yang sama yang digunakan untuk memverifikasi email Anda.',
  WithTheAccessToViewTheDocument: ' dengan akses untuk melihat dokumen.',
  ViewActivity: 'Lihat aktivitas',
  PasscodeIsNotCorrect: 'Kode sandi salah',
  SubmissionDocumentUploaded: '1 dokumen diunggah untuk diserahkan.',
  SubmissionDocumentsUploaded:
    '${NumberOfDocuments} dokumen diunggah ke penyerahan.',
  HowSubmissionsWork: 'Cara kerja pengiriman',
  AllAddedDocumentsAreAutomaticallySubmitted:
    'Semua dokumen yang ditambahkan akan dikirimkan secara otomatis.',
  YouHaveUntilTheCloseOfTheSubmissionWindowToMakeChanges:
    'Anda memiliki waktu hingga penutupan jendela pengiriman untuk membuat perubahan.',
  UntilClose: 'sampai dekat',
  Ansarada: 'Ansarada',
  BulkEditFileUpload: `atau seret dan letakkan Excel yang sudah disempurnakan di sini. Kami akan menyajikan ikhtisar singkat hasil suntingan.`,
  BulkEditFileUploadAfterUploading:
    'atau seret dan letakkan berkas yang benar di sini untuk beralih dengan mudah.',
  BulkEditExcelReady: 'Tepat sasaran, ${name}! Sudahkah Anda mengedit Excel?',
  BeforeYourEdits: 'Sebelum Anda mengedit',
  AfterYourEdits: 'Setelah suntingan Anda',
  DropFilesHereToAttach: 'Letakkan file di sini untuk dilampirkan',
  KickOffBy: 'Kick-off oleh',
  DownloadingTheExcelVersion: 'mengunduh versi Excel',
  OfYourDocumentIndex: 'Indeks Dokumen Anda.',
  BulkEditNextButtonGuide:
    'Setelah menyempurnakan, ketuk tombol <strong>Berikutnya</strong> untuk mengunggah dan menyaksikan efisiensi dalam tindakan.',
  BulkEditDownloadExcelFileHeading:
    'Tingkatkan Alur Kerja Anda: Pengeditan Dokumen Menjadi Mudah.',
  BulkEditAllSetHeading: 'Semua sudah siap, ${name}! Anda siap beraksi.',
  BulkEditButtonGuide:
    'Setelah Anda menekan tombol <strong>Edit massal</strong> , kami siap mengubah ${combinedText} sesuai arahan Anda.',
  ProTip: 'Tips profesional?',
  ProTipDescription:
    'Pertimbangkan untuk mengunduh versi Excel terbaru dari Indeks Dokumen Anda. Versi ini akan memberi Anda gambaran yang jelas sebelum pengeditan dimulai.',
  GrabItHere: 'Ambil di sini.',
  BulkEditSuccessMessage: `Pembaruan massal Anda telah diterapkan dan sekarang ada di Indeks Dokumen. Kami siap membantu Anda!`,
  NotTheRightExcel: 'Bukan Excel yang tepat?',
  UploadFailedMessage:
    'Pengunggahan gagal, ${name}. Terjadi masalah saat mengunggah. Silakan coba lagi.',
  FailedMessage:
    'Pembaruan Gagal, ${name}. Terjadi masalah dengan pembaruan massal. Silakan coba lagi.',
  DoNotHaveAccessMessage:
    'Anda tidak memiliki akses ke beberapa dokumen & folder yang diubah di Excel yang disediakan, silakan minta administrator Ruang Data untuk melakukan operasi tersebut',
};
